import React from "react";
import cn from "classnames";
import styles from "./styles.module.scss";

export type StatusTone =
  | "moderation"
  | "launch"
  | "active"
  | "paused"
  | "done"
  | "canceled";

// Order statuses mapped to the client's OrderTimeline tones.
export const getStatusTone = (status?: string | null): StatusTone => {
  switch ((status || "").toUpperCase()) {
    case "MODERATION":
      return "moderation";
    case "LAUNCH":
    case "LAUNCHING":
      return "launch";
    case "PAUSED":
      return "paused";
    case "DONE":
    case "COMPLETED":
      return "done";
    case "CANCELED":
    case "CANCELLED":
    case "REFUNDED":
      return "canceled";
    default:
      return "active";
  }
};

// "IN_PROGRESS" -> "In progress"
const formatStatus = (status: string) => {
  const text = status.replace(/_/g, " ").toLowerCase();
  return text.charAt(0).toUpperCase() + text.slice(1);
};

interface StatusBadgeProps {
  status?: string | null;
  className?: string;
}

/** Status pill: soft tone background, strong tone text, 12/16 medium. */
const StatusBadge: React.FC<StatusBadgeProps> = ({ status, className }) => {
  if (!status) return <>—</>;
  return (
    <span
      className={cn(styles.badge, styles[getStatusTone(status)], className)}
    >
      {formatStatus(status)}
    </span>
  );
};

export default StatusBadge;
